<nav class="navbar navbar-dark navbar-expand-lg d-none d-lg-flex bg-primary position-relative">
  <!--Logos on nav bar-->
  <a class="navbar-brand py-0 ms-2" [routerLink]="['/']" routerLinkActive="router-link-active">
    <img alt="" class="ms-1 h-100" aria-labelledby="homeLink" src="assets/images/club-logo.png" draggable="false" />
  </a>

  <div class="nav-container position-absolute" *notInProductCode="[productCode.NonRenewing]">
    <ul class="navbar-nav navbar-nav-container" #greedyNav>
      <li class="nav-item mx-2 active">
        <a class="nav-link" [routerLink]="['/rewards']" routerLinkActive="router-link-active">
          {{ 'navbar.rewards' | translate : { fgbdefault: 'Rewards' } }}
        </a>
      </li>
      <li class="nav-item mx-2 active">
        <a class="nav-link" [routerLink]="['/challenges']" routerLinkActive="router-link-active">
          {{ 'nav.challenges' | translate : { fgbdefault: 'Challenges' } }}
        </a>
      </li>
      <li class="nav-item mx-2 active">
        <a class="nav-link mx-1" [routerLink]="['/games']" routerLinkActive="router-link-active">{{ 'nav.games' | translate }}</a>
      </li>
      <li class="nav-item mx-2 active">
        <a class="nav-link mx-1" [routerLink]="['/rewards/wallet']" routerLinkActive="router-link-active">{{
          'nav.wallet' | translate
        }}</a>
      </li>
    </ul>
  </div>

  <!-- Right Side Content -->
  <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0 right-side-container ms-auto me-3">
    <!--Points Balance-->
    <div class="balance font-size-14 text-white gloss me-3" *notInProductCode="[productCode.NonRenewing]">
      <div class="d-flex align-items-center" *ngIf="loyaltyPointsCard$">
        <span class="icon material-icons currency-icons pe-2">loyalty</span>
        <span class="fw-bold text-nowrap">{{ loyaltyPointsCard$ | async | FortressCurrencyPipe : 'PTS' }}</span>
      </div>
    </div>

    <button
      class="nav-link btn text-white d-flex align-items-center px-0 justify-content-end ms-auto"
      (click)="isNavOpen = !isNavOpen"
      attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
      tabindex="-1"
      focusTab
    >
      <i class="material-symbols-outlined material-icons">menu</i>
    </button>
  </div>
</nav>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div
  class="right-nav-menu shadow bg-tertiary"
  [@rightNavAnimation]="isNavOpen ? 'open' : 'close'"
  [ngClass]="{ open: isNavOpen }"
>
  <div class="right-nav-menu-header">
    <div id="brand-logo">
      <img alt="" aria-labelledby="homeLink" src="assets/images/club-logo.png" draggable="false" />
    </div>
    <button class="btn-nav-close text-info pe-0" (click)="isNavOpen = false">
      <i class="material-icons text-white">close</i>
    </button>
  </div>

  <ng-container *ngIf="memberDetails$ | async as memberDetails">
    <div class="member-info">
      <div class="d-flex justify-content-between align-items-center">
        <!--Name and ID-->
        <div class="card-id text-start">
          <h5 class="mb-1 card-name">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</h5>
          <div class="d-flex product-code mt-2 font-size-14">
            {{ ('member.card.id' | translate) + ' : ' + memberDetails.ExternalRefNumber }}
          </div>
        </div>
      </div>
    </div>
    <div class="right-nav-menu-list">
      <ul *notInProductCode="productCode.NonRenewing" class="navbar-nav me-auto w-100" #greedyNav>
        <li class="nav-item active">
          <a
            [routerLink]="['/account']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.account.screenreader' | translate : { fgbdefault: 'Move to account page' } }}"
            class="d-flex align-items-center account-btn text-white bg-tertiary py-0 px-2 font-size-14 nav-item-fixed-height rounded-top right-nav-menu-item"
            ngbDropdownItem
          >
            <span class="icon material-icons material-symbols-outlined material-dropdown-icon me-2" aria-hidden="true"
              >account_circle</span
            >
            <div class="dropdown-link text-start">
              <div class="mt-0 nav-text">{{ 'nav.dropdown.account' | translate }}</div>
            </div>
          </a>
        </li>
        <li>
          <button
            class="d-flex align-items-center text-white bg-tertiary py-0 px-2 font-size-14 nav-item-fixed-height p w-100 border-0 right-nav-menu-item justify-content-between"
            attr.aria-label="{{ 'nav.help.screenreader' | translate : { fgbdefault: 'Click for help pages' } }}"
            (click)="isCollapsed = !isCollapsed"
          >
            <div class="d-flex align-items-center">
              <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">info</span>
              <div class="dropdown-link text-start">
                <div class="nav-text mt-0">{{ 'nav.help' | translate }}</div>
              </div>
            </div>
            <span
              [@expandAnimation]="isCollapsed ? 'close' : 'open'"
              class="icon material-icons material-dropdown-icon m-0"
              aria-hidden="true"
              >keyboard_arrow_down</span
            >
          </button>
          <ul class="sub-nav text-white" *ngIf="isCollapsed">
            <li class="nav-item active">
              <a
                class="nav-link mx-1 right-nav-menu-item"
                [routerLink]="['/terms']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.terms.screenreader' | translate : { fgbdefault: 'Move to terms page' } }}"
                >{{ 'nav.terms' | translate }}</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link mx-1 right-nav-menu-item"
                [routerLink]="['/faq']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.faq.screenreader' | translate : { fgbdefault: 'Move to faq page' } }}"
                >{{ 'nav.faq' | translate }}</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link mx-1 right-nav-menu-item"
                [routerLink]="['/contact']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.contact.us.screenreader' | translate : { fgbdefault: 'Move to contact us page' } }}"
                >{{ 'nav.contact.us' | translate }}</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <a class="logout-btn text-error cursor-pointer mt-auto" (click)="logout()">
      <i class="material-symbols-outlined material-icons me-2">logout</i>
      <span>{{ 'nav.log.out' | translate }}</span>
    </a>
  </ng-container>
</div>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>
